import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Mutation } from '@apollo/client/react/components';
import { gql } from '@apollo/client';
import { get as lodashGet } from 'lodash';

import { updateCommentsCacheAddEdge } from './ActivitiesDataProvider';
import { GQL_COMMENT_FRAGMENT } from './fragments';

const GQL_ADD_COMMENT = gql`
  mutation AddComment($input: CommentCreateInput!) {
    commentCreate(input: $input) {
      __typename
      recordable {
        __typename
        ... on Node {
          id
        }
        ... on Photo {
          databaseId
        }
        ... on RecordableInterface {
          commentsCount
        }
      }
      newCommentEdge {
        node {
          ...CommentFragment
        }
      }
      errors {
        message
        path
        error
      }
    }
  }

  ${GQL_COMMENT_FRAGMENT}
`;

const edgeFromData = (data) =>
  lodashGet(data, 'commentCreate.newCommentEdge', {});

const recordableFromData = (data) =>
  lodashGet(data, 'commentCreate.recordable', {});

const errorsFromData = (data) => lodashGet(data, 'commentCreate.errors', []);

const updateCache = ({ cache, data }) => {
  const gqlErrors = errorsFromData(data);
  if (gqlErrors.length) {
    return;
  }

  const newEdge = edgeFromData(data);
  const recordable = recordableFromData(data);
  updateCommentsCacheAddEdge({ cache, newEdge, nodeId: recordable.id });
};

const MutationAddComment = ({ children }) => (
  <Mutation
    mutation={GQL_ADD_COMMENT}
    update={(cache, { data }) => updateCache({ cache, data })}
  >
    {(mutation) => {
      return children({
        addComment: (input) => mutation({ variables: { input } }),
      });
    }}
  </Mutation>
);

MutationAddComment.propTypes = {
  children: PropTypes.func,
};

export default connect()(MutationAddComment);
